<template>
  <v-row dense class="pa-0">
    <v-col cols="12">
      <px-autocomplete-cadastro-adicional
        :dense="dense"
        type="CONTA_FINANCEIRA"
        label="Classe financeira"
        required
        class="required rounded-tag-small"
        v-model="formData.contaFinanceira">
        <template v-slot:append-outer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon
                     class="pb-2 pr-2"
                     v-on="on"
                     :disabled="!formData.contaFinanceira"
                     @click="onClickReplicarCampo(formData.contaFinanceira)">
                <v-icon v-on="on">
                  mdi-clipboard-arrow-down
                </v-icon>
              </v-btn>
            </template>
            <span>Replicar campo aos outros produtos</span>
          </v-tooltip>
        </template>
      </px-autocomplete-cadastro-adicional>
    </v-col>
    <v-col cols="12">
      <px-autocomplete-cadastro-adicional
        :dense="dense"
        type="OPERACAO"
        label="Operação"
        required
        class="required rounded-tag-small"
        v-model="formData.operacao">
        <template v-slot:append-outer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon
                     class="pb-2 pr-2"
                     v-on="on"
                     :disabled="!formData.operacao"
                     @click="onClickReplicarCampo(formData.operacao)">
                <v-icon v-on="on">
                  mdi-clipboard-arrow-down
                </v-icon>
              </v-btn>
            </template>
            <span>Replicar campo aos outros produtos</span>
          </v-tooltip>
        </template>
      </px-autocomplete-cadastro-adicional>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClickReplicarCampo(campo) {
      this.$emit('replicar-campo', campo);
    },
  },
};
</script>
